module.exports = __webpack_public_path__ + "static/media/at.c413c43d.svg";